"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueService = void 0;
class ValueService {
    constructor() {
        this.providers = {};
        this.listeners = {};
    }
    setProvider(key, provider) {
        if (this.hasProvider(key)) {
            this.clearProvider(key);
        }
        const removeEventValueListener = provider.registerValueEventListener(() => {
            this.triggerListeners(key);
        });
        this.providers[key] = {
            provider,
            removeEventValueListener,
        };
    }
    getProvider(key) {
        if (!this.hasProvider(key)) {
            throw new Error(`getProvider: ${key} not available`);
        }
        return this.providers[key].provider;
    }
    hasProvider(key) {
        return key in this.providers;
    }
    clearProvider(key) {
        if (!this.hasProvider(key)) {
            throw new Error(`clearProvider: ${key} not available`);
        }
        this.providers[key].removeEventValueListener();
        delete this.providers[key];
    }
    registerListener(key, listener) {
        if (key in this.listeners === false) {
            this.listeners[key] = [];
        }
        const fn = listener;
        this.listeners[key].push(fn);
        return () => {
            const index = this.listeners[key].indexOf(fn);
            if (index < 0) {
                throw new Error("Listener not found.");
            }
            this.listeners[key].splice(index, 1);
        };
    }
    triggerListeners(key) {
        if (key in this.listeners === false) {
            return;
        }
        const { provider } = this.providers[key];
        for (const listener of this.listeners[key]) {
            listener(provider);
        }
    }
}
exports.ValueService = ValueService;
//# sourceMappingURL=ValueService.js.map